import React from 'react';
import './NotFound.css';
const NotFound = () => {
    return (
        <div className="text-center ">
        <h1 className="text-danger">Opppppppppsssssssss!!!</h1>
        <img className="responsive" src="https://cdn.dribbble.com/users/62549/screenshots/3894903/media/c3a11496923b170c18c947fe93d13261.gif" alt="" />
    </div>
    );
};

export default NotFound;